import { SupernovaApiClient } from "@supernova-studio/client"

import { VaultService } from "../services/vault.service.js"
import { apiUrlForEnvironment, TargetEnv } from "../types/environment.js"

const vaultService = new VaultService()

export const getApiClient = async (env: TargetEnv): Promise<SupernovaApiClient> => {
  const { accessToken } = await vaultService.getTokensFromVault(env)
  return new SupernovaApiClient({ accessToken, baseUrl: apiUrlForEnvironment(env, null) })
}
